import { ListGroupItem } from "react-bootstrap";
import { Link } from "react-router-dom";
import type { InsightsController } from "../../../api/src/insights/insights.controller";
import type { UnpackResponse } from "../../../api/src/lib";
import Loading from "../Loading";
import InsightFailed from "./InsightFailed";
import { useAuthenticatedQuery } from "../lib/api";

function useQueryUnmappedSecuritiesInsight() {
  return useAuthenticatedQuery<
    UnpackResponse<InsightsController["unmappedSecurities"]>,
    number,
    [string, string]
  >({
    queryKey: ["insights", "unmapped-securities"],
    queryFn: async (unmappedSecurities) => unmappedSecurities.data,
  });
}

const UnmappedSecurities = () => {
  const {
    isPending: isPendingUnmappedSecurities,
    data: dataUnmappedSecurities,
  } = useQueryUnmappedSecuritiesInsight();

  return isPendingUnmappedSecurities ? (
    <ListGroupItem>
      <Loading />
    </ListGroupItem>
  ) : typeof dataUnmappedSecurities === "undefined" ? (
    <InsightFailed />
  ) : (
    <ListGroupItem>
      You have{" "}
      {dataUnmappedSecurities <= 0 ? (
        "0 securities"
      ) : (
        <Link to="/firm/security-master?filter=unmapped">
          {dataUnmappedSecurities} securities
        </Link>
      )}{" "}
      in your holdings or models that are missing a Security Category.
    </ListGroupItem>
  );
};

export default UnmappedSecurities;
